import { useTheme } from '@mui/material/styles';
import { Text, TextProps } from 'components/Text';

interface Props extends TextProps {
  crossed?: boolean;
}
export const LightGrayLabel = ({ crossed, sx, ...rest }: Props) => {
  const theme = useTheme();

  return (
    <Text
      {...rest}
      sx={{
        color: theme.palette.text.disabled,
        textDecoration: crossed ? 'line-through' : 'none',
        ...sx
      }}
    />
  );
};
